import { MessageCircle } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { useConfig, waLink } from "@/context/ConfigContext";

export default function EnquirySection() {
  const config = useConfig();

  return (
    <section id="enquire" data-testid="enquiry-section" className="bg-navy py-24 text-white lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-start">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              dark
              chapter="07"
              eyebrow="Get In Touch"
              title="Looking for a Plot in Nagpur?"
              description="Tell us what you're looking for and our team will get in touch."
            />
            <Reveal delay={0.2}>
              <a
                href={waLink(config)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-cta-button"
                className="mt-9 inline-flex items-center gap-3 rounded-sm bg-[#25D366] px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-transform duration-200 hover:scale-[1.03]"
              >
                <MessageCircle className="h-5 w-5" aria-hidden="true" />
                Chat With Us on WhatsApp
              </a>
            </Reveal>
            <Reveal delay={0.28}>
              <ul className="mt-9 space-y-3 text-sm text-white/60">
                <li className="flex items-center gap-3">
                  <span className="h-px w-6 bg-gold" aria-hidden="true" />
                  Site visit assistance for available properties
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-px w-6 bg-gold" aria-hidden="true" />
                  Clear, transparent property information
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-px w-6 bg-gold" aria-hidden="true" />
                  Residential, commercial and investment options
                </li>
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="rounded-xl bg-white p-6 text-navy shadow-2xl sm:p-9">
              <EnquiryForm />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
